module.exports = __webpack_public_path__ + "static/media/minecrat.89822579.jpg";